export default __webpack_public_path__ + "static/media/032-abu simbel.304cb51d.svg";